<template>
  <div v-if="camera.devices && camera.camera_type === 'alarm_bridge_pacom'">
    <div
      v-for="device in filteredDevices"
      :key="device.text"
      class="device-item d-flex justify-content-start align-items-center border rounded"
      style="margin: 3px; background: white;"
      :draggable="!usedDeviceIds.has(getCameraProxyId(device))"
      :style="usedDeviceIds.has(getCameraProxyId(device))
        ? { opacity: 0.4, cursor: 'not-allowed' }
        : { cursor: 'grab' }"
      @dragstart.stop="!usedDeviceIds.has(getCameraProxyId(device)) && emitDrag(device)"
    >
      <img :src="setImage(device)" width="18px" />
      <span class="status-dot" style="flex-shrink: 0;"></span>
      <span
        class="device-name"
        v-b-tooltip.hover
        :title="device.text"
      >
        {{ device.text ? (device.text.length > 20 ? device.text.substring(0, 20) + '...' : device.text) : '' }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlarmBridgePacom",
  props: {
    camera:        { type: Object,   required: true },
    setImage:      { type: Function, required: true },
    usedDeviceIds: { default: () => new Set() },
    cameraList:    { type: Array,    default: () => [] },
    hideHeader:    { type: Boolean,  default: false },
    filter: { type: String, default: '' },
  },
  computed: {
    filteredDevices() {
      if (!this.filter) return this.camera.devices || []
      return (this.camera.devices || []).filter(d =>
        d.text?.toLowerCase().includes(this.filter.toLowerCase())
      )
    }
  },
  data() {
    return { hoveredItem: null }
  },
  methods: {
    getCameraProxyId(device) {
      const match = this.cameraList.find(c => c.id === device.device_id || c.id === device.id)
      return match?.camera_proxy_id ?? match?.id_camera_proxy ?? device.id
    },
    emitDrag(device) {
      const match = this.cameraList.find(c => c.id === device.device_id)
      this.$emit('drag-device', {
        ...device,
        name:              device.text,
        id_camera_proxy:   match?.camera_proxy_id ?? match?.id_camera_proxy ?? null,
        camera_proxy_id:   match?.camera_proxy_id ?? match?.id_camera_proxy ?? null,
        device_type:       match?.device_type ?? device.device_type ?? null,
        camera_type:       match?.camera_type ?? null,
        panel_device_type: device.device_type,
      })
    }
  }
}
</script>

<style scoped>
.device-item { padding: 5px; cursor: pointer; transition: background 0.2s ease; }
.device-item:hover { background: #f4f4f4; }
.device-item img { transition: transform 0.2s ease; }
.device-item:hover img { transform: scale(1.1); }
.device-name { font-size: 14px; padding-left: 5px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.status-dot { width: 8px; height: 8px; border-radius: 50%; margin-left: 5px; background-color: #28a745; display: inline-block; }
.status-dot.off { background-color: #dc3545; }
</style>